
import { defineComponent } from 'vue'
import PatientAppointments from './PatientAppointments.vue'
// import PatientSummary from '../shared/PatientSummary.vue'

export default defineComponent({
  name: 'AppointmentSchedule',
  components : { PatientAppointments },
  data () {
    return {
      patientSummary: {
        name: 'Coco Jamz',
        birthdate: '01 Jan 1994',
        age: '21',
        location: 'Ward 12',
        hrn: 44332211
      },
      appointmentDate: new Date().toISOString().substr(0, 10)
    }
  }
})
